import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { ClaimAnalysisResponse } from '../types/claim-analysis';

/**
 * 权利要求分析结果模型接口
 *
 * 用于管理 OAR 任务中权利要求分析的结果数据，包括：
 * - 任务和结论性意见标识信息
 * - 权利要求分析结果列表
 * - 分析统计信息
 */
export interface ClaimAnalysisResultModel extends Model<ClaimAnalysisResponse>, Disposable {}

/**
 * 权利要求分析结果模型依赖注入符号
 */
export const ClaimAnalysisResultModel = Symbol.for('ClaimAnalysisResultModel');
